import { API } from 'app/routes';
import axios from 'axios';
import { Action, action, Thunk, thunk } from 'easy-peasy';
import { StoreModel } from '~/store';
import { ChecklistItemAssetMap, Training, TRAINING_STATUS, TrainingDetail, TrainingResponsePayload } from './types';
import { jsonToFormData } from '~/app/helpers/headerContentType';

export interface TrainingModel {
    fetching: boolean
    setFetching: Action<TrainingModel, boolean>
    fetch: Thunk<TrainingModel, string, void, StoreModel, Promise<void>>
    fetchTraining: Thunk<TrainingModel, string, void, StoreModel, Promise<void>>
    saveTraining: Thunk<TrainingModel, any, void, StoreModel, Promise<TrainingResponsePayload>>
    updateTraining: Thunk<TrainingModel, { id: string, mode: 'status', status: TRAINING_STATUS, comment: string }, void, StoreModel, Promise<TrainingResponsePayload>>
    data: TrainingDetail
    setData: Action<TrainingModel, TrainingDetail>
    checklist: ChecklistItemAssetMap[]
    setChecklist: Action<TrainingModel, ChecklistItemAssetMap[]>
    fetchChecklist: Thunk<TrainingModel, void, void, StoreModel, Promise<void>>
}

export const trainingModel: TrainingModel = {
    fetching: false,
    setFetching: action((state, payload) => {
        state.fetching = payload;
    }),
    fetch: thunk((actions, payload, { getStoreState, getStoreActions }) => {
        const storeData = getStoreState();
        const storeActions = getStoreActions();
        actions.setFetching(true);
        return axios.get<null, Training[]>(`${API.training}/fetch/${payload}`)
            .then(data => {
                storeActions.machine.fetchedMachine({
                    ...storeData.machine.data,
                    trainings: data
                })
            })
            .finally(() => actions.setFetching(false));
    }),
    fetchTraining: thunk((actions, payload) => {
        actions.setFetching(true);
        return axios.get<null, TrainingDetail>(`${API.training}/${payload}`).then(data => actions.setData(data)).finally(() => actions.setFetching(false));
    }),
    saveTraining: thunk((actions, payload) => {
        actions.setFetching(true);
        return axios.post<null, TrainingResponsePayload>(`${API.training}/save`, jsonToFormData(payload)).then(data => data).finally(() => actions.setFetching(false));
    }),
    updateTraining: thunk((actions, payload) => {
        actions.setFetching(true);
        return axios.post<null, TrainingResponsePayload>(`${API.training}/${payload.id}/update`, payload).then(data => data).finally(() => actions.setFetching(false));
    }),
    data: {
        id: '',
        title: '',
        participants: [],
        instructor: {
            id: '',
            name: '',
            email: '',
            phone: '',
            avatar: '',
            added: false,
            deleted: false,
            new: false
        },
        trainingDate: '',
        checklist: [],
        externalResources: [],
        commentFromInstructor: '',
        status: TRAINING_STATUS.NOTAPPLICABLE,
        comment: '',
        images: [],
        pdfs: [],
        excavators: []
    },
    setData: action((state, payload) => {
        state.data = { ...payload };
    }),
    checklist: [] as ChecklistItemAssetMap[],
    setChecklist: action((state, payload) => {
        state.checklist = payload;
    }),
    fetchChecklist: thunk(actions => {
        actions.setFetching(true);
        return axios
            .get<null, { data: ChecklistItemAssetMap[] }>(`${API.training}/get_training_checklist`)
            .then(data => actions.setChecklist(data.data))
            .finally(() => actions.setFetching(false));
    })
};
